import React from 'react';
import { Link } from 'react-router-dom';
import './HomePage.css';


const topics = [
  { name: 'Spiritual', image: '/images/wf-spiritual2.webp', link: '/spiritual' },
  { name: 'Physical', image: '/images/wf-physical2.jpg', link: '/physical' },
  { name: 'Intellectual', image: '/images/wf-intellectual.jpg', link: '/intellectual' },
  { name: 'Relational', image: '/images/wf-relational2.jpg', link: '/relational' },
  { name: 'Emotional', image: '/images/wf-emotional2.jpg', link: '/emotional' },
  { name: 'Habits', image: '/images/wf-habits2.jpg', link: '/habits' },
];

const HomePage = () => {
  return (
    <>
      <div className="hero-section">
        <img
          className="homepage-image"
          src="/images/wf-forward2.jpg"
          alt="modern michelangelo"
        />
  <div className="hero-content">
    <h1 className="hero-title">To better health.</h1>
    <div className="micro-void"></div>
    <div className="cta-container">
      <div className="cta-box">
        <p className="cta-text">Watch your gratitude grow →</p>
        <Link to="/gratitude" className="grati-link">
  <img src="/images/grateful.png" alt="GratiSphere" className="grati-image" />
</Link>
      </div>

      <div className="cta-box">
        <p className="cta-text">Weigh in, move forward →</p>
        <Link to="/weight-tracker2">
    <img src="/images/weigh2.png" alt="WeighForward" className="grati-image" />
  </Link>
      </div>
    </div>
  </div>
</div>
      <div className="page-container">
        <div className="homepage-section">
          <section className="cta-section">
          <p className="homepage-subtitle" style={{ textAlign: 'center' }}>
          <italic>Start tracking your journey to better health today.</italic>
          </p>
          <hr className="section-divider" />
          <p className="homepage-subtitle" style={{ textAlign: 'center' }}>Your path to wholeness begins here—explore the topics below.</p>
        </section>
          <h2 className="homepage-heading">Topics</h2>
          <div className="topics-grid">
            {topics.map((topic) => (
              <Link to={topic.link} key={topic.name} className="topic-card">
                <img src={topic.image} alt={topic.name} className="topic-image" />
                <p>{topic.name}</p>
              </Link>
            ))}
          </div>
        </div>
        <div className="homepage-section">
          <h2 className="homepage-heading">What is Wholeness Forward?</h2>
          <p className="homepage-text">
          Health is a journey, not a destination. At Wholeness Forward, we provide science-backed information,
           tools, and resources to help you navigate your unique path to optimal health.</p>
        </div>
        <div className="homepage-section">
          <h2 className="homepage-heading">The SPIRE Model</h2>
          <p className="homepage-text">
          Wholeness Forward is inspired by the SPIRE model, created by Tal Ben-Shahar, 
          a leader in positive psychology.
          </p>
          <ul className="homepage-values-list">
            <li><Link to="/spiritual"><strong>Spiritual</strong></Link></li>
            <li><Link to="/physical"><strong>Physical</strong></Link></li>
            <li><Link to="/intellectual"><strong>Intellectual</strong></Link></li>
            <li><Link to="/relational"><strong>Relational</strong></Link></li>
            <li><Link to="/emotional"><strong>Emotional</strong></Link></li>
          </ul>
          <p className="homepage-text">
          The SPIRE model helps you thrive by integrating all areas of well-being.
          </p>
        </div>
      </div>
    </>
  );
};

export default HomePage;
